import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthNavigator } from './components/auth/AuthNavigator';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { ErrorBoundaryTest } from './components/ErrorBoundaryTest';
import Footer from './components/Footer';
import Navbar from './components/navbar/Navbar';
import { ModalProvider } from './contexts/ModalContext';
import AuthCallbackPage from './pages/AuthCallbackPage';
import AuthorizedAgentsPage from './pages/AuthorizedAgentsPage';
import HomePage from './pages/HomePage';

// Pages
import PoolDetailPage from './pages/PoolDetailPage';
import PoolsPage from './pages/PoolsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsServicePage from './pages/TermsServicePage';
import { QueryProvider } from './providers/QueryProvider';
import { getPublicRuntimeConfig } from './utils/publicRuntimeConfig';

function AppContent() {
  const showBoundaryTest = getPublicRuntimeConfig().showErrorBoundaryTest;

  return (
    <>
      {showBoundaryTest && <ErrorBoundaryTest />}
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/auth-callback" element={<AuthCallbackPage />} />
        <Route
          path="/pools"
          element={
            <ProtectedRoute>
              <PoolsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pools/:poolId"
          element={
            <ProtectedRoute>
              <PoolDetailPage />
            </ProtectedRoute>
          }
        />
        <Route path="/terms-of-service" element={<TermsServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/authorized-agents" element={<AuthorizedAgentsPage />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <QueryProvider>
        <ModalProvider>
          <AuthNavigator /> {/* syncs auth state + handles redirects */}
          <AppContent />
        </ModalProvider>
      </QueryProvider>
    </BrowserRouter>
  );
}

export default App;
